/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Top Nav Help Icon component.
 */
export const TopNavHelpIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <circle cx={12}
        cy={12}
        r={11.077}
        stroke={dlsColor('grey3')}
        strokeWidth={1.5} />
      <path d='M11.008 15.566c.01-.62.08-1.11.21-1.469s.396-.758.797-1.195l1.024-1.055c.438-.494.656-1.026.656-1.593 0-.547-.143-.974-.43-1.282-.286-.312-.703-.468-1.25-.468-.53 0-.958.14-1.28.421-.324.282-.485.66-.485 1.133H8.805c.01-.843.31-1.523.898-2.039.594-.52 1.365-.781 2.313-.781.984 0 1.75.266 2.296.797.553.526.829 1.25.829 2.172 0 .911-.422 1.81-1.266 2.695l-.852.844c-.38.422-.57 1.028-.57 1.82h-1.445zm-.063 2.477c0-.235.07-.43.211-.586.146-.162.36-.242.64-.242.282 0 .496.08.641.242a.825.825 0 01.22.586c0 .234-.074.43-.22.586-.145.15-.359.226-.64.226-.282 0-.495-.075-.64-.226a.843.843 0 01-.212-.586z'
        fill={iconColor} />
    </svg>
  );
};
export default TopNavHelpIcon;
